import { useState } from 'react'
import { SiteHeader } from '@/components/site-header'
import SponsorAdData from '@/components/sponsor-ad/SponsorAdData'

import { AdStatistics } from '@/components/sponsor-ad/AdStatistics'

function SponsorAdManagement() {
  const [searchQuery, setSearchQuery] = useState('')
  const [showSearch, setShowSearch] = useState(true)

  const handleSearchChange = (value: string) => {
    setSearchQuery(value)
  }

  const handleShowSearch = (val: boolean) => {
    setShowSearch(val)
  }

  return (
    <main
      className="@container/main flex flex-1 flex-col"
      id="main-content"
      tabIndex={-1}
      aria-label="Sponsor Ad Management Main Content"
    >
      <section
        aria-label="Sponsor Ad Management Header and Actions"
        className="flex flex-col gap-2"
      >
        <SiteHeader
          title="Sponsor Ad Management"
          subtitle="Manage sponsor advertisements, review campaigns, and monitor performance."
          searchPlaceholder="Search"
          searchValue={searchQuery}
          onSearchChange={handleSearchChange}
          showSearch={showSearch}
        />
        <AdStatistics />
      </section>

      <SponsorAdData search={searchQuery} handleShowSearch={handleShowSearch} />
    </main>
  )
}

export default SponsorAdManagement
